import { CircleAlert } from 'lucide-react';
import { z } from 'zod';

import { defineStandalone } from '@apps/web/features/phoebe_chat_v3/registry/types';
import { EventLine } from '@apps/web/features/phoebe_chat_v3/ui/primitives/event_line';

// The payload's error_type/error_message are backend internals (exception
// text, SQL, provider errors) and must never render; the transcript records
// only that this response ended in an error.
const CUSTOMER_COPY = 'Something went wrong. Please try again.';

const payloadSchema = z.object({
    error_type: z.string(),
    error_message: z.string(),
    error_recoverability: z
        .enum(['recoverable', 'irrecoverable'])
        .nullable()
        .optional(),
});

export const runFailedDefinitions = {
    run_failed: defineStandalone('run_failed', {
        disposition: 'render',
        schema: payloadSchema,
        malformed: {
            kind: 'placeholder',
            customerCopy: CUSTOMER_COPY,
        },
        evidence(_payload, occurrence) {
            if (occurrence.committed === null) {
                return null;
            }
            return {
                kind: 'run_terminal',
                eventId: occurrence.committed.id,
                occurredAtMs: Date.parse(occurrence.committed.created_at),
            };
        },
        group: null,
        render() {
            return (
                <EventLine glyph={<CircleAlert />}>{CUSTOMER_COPY}</EventLine>
            );
        },
    }),
} as const;

export const runFailedContractFixtures = {
    valid: {
        type: 'run_failed',
        error_type: 'provider-error-type-sentinel',
        error_message: 'provider-error-message-sentinel',
        error_recoverability: 'irrecoverable',
        raw_error_message: 'raw-provider-error-sentinel',
    },
    malformed: {
        type: 'run_failed',
        error_type: 'provider-error-type-sentinel',
        error_message: 400,
    },
} as const;
